import { WorkawareApi } from 'apis/WorkawareApi'
import { transform, TransformMethods } from 'data/transform'
import { JourneyCheckPointModel } from '../models/JourneyCheckPointModel'


export class JourneyCheckPointService{
    private _api : WorkawareApi
    private _checkPointTransform :TransformMethods<JourneyCheckPointModel>

    constructor(api: WorkawareApi) {
        this._api = api
        this._checkPointTransform = transform<JourneyCheckPointModel>(JourneyCheckPointModel)
      }
      createJourneyCheckPoint =(journeyCheckpoints:JourneyCheckPointModel) =>
      {
        return new Promise<JourneyCheckPointModel>((resolve,reject) =>
        {
          this._api.journeyCheckPoints
              .post(journeyCheckpoints)
              .then((journeyCheckpoint) =>resolve(this._checkPointTransform.from(journeyCheckpoint)))
              .catch((error) =>reject(error))
        })
      }
      updateJourneyCheckPoint = (id: number, checkpoint: JourneyCheckPointModel) => {
      return new Promise<JourneyCheckPointModel>((resolve, reject) => {
      this._api.journeyCheckPoints
      .update(id, checkpoint)
      .then((response) => resolve(this._checkPointTransform.from(response)))
      .catch((error) => reject(error))
        })
      }
      deleteJourneyCheckPoint = (id: number) => {
       return new Promise((resolve, reject) => {
       this._api.journeyCheckPoints
      .delete(id)
      .then(result => resolve(result))
      .catch(error => reject(error))
      })
}
      setCheckpointStatus = (id: number, data: { StatusId: number; Comment: string; TargetUserId?: number }) => {
        return new Promise<JourneyCheckPointModel>((resolve, reject) => {
          this._api.journeyCheckPoints
            .setStatus(id, data)
            .then((response) => resolve(this._checkPointTransform.from(response)))
            .catch((error) => reject(error))
        })
      }

    }